import React from "react";

import "./index.scss";

const ChartIcon = props => (
  <svg id="Charts_SVG" data-name="Dashboard" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" className="chart-icon">
    <g id="Charts" transform="translate(16 16)">
      <g id="Group_8724" data-name="Group 8724" transform="translate(-16 -16)" className={`default ${props.active ? "active" : ""}`}>
        <path id="Path_8549" data-name="Path 8549" className="cls-1" d="M0,0H32V32H0Z" />
        <rect id="Rectangle_246" data-name="Rectangle 246" className="cls-2" width="24" height="24" rx="1" transform="translate(4 4)" />
        <g id="Group_8723" data-name="Group 8723">
          <rect id="Rectangle_243" data-name="Rectangle 243" className="cls-3" width="1.412" height="4.235" transform="translate(20.941 18.118)" />
          <rect id="Rectangle_244" data-name="Rectangle 244" className="cls-3" width="1.412" height="12.706" transform="translate(15.294 9.647)" />
          <rect id="Rectangle_245" data-name="Rectangle 245" className="cls-3" width="1.412" height="8.471" transform="translate(9.647 13.882)" />
        </g>
      </g>
    </g>
  </svg>
);

export default ChartIcon;
